import { Link, useSearchParams } from 'react-router';
import { EmptyBoard } from '../components/illustrations';
import { Paper } from '../components/Paper';
import { EmptyState } from '../components/States';
import { FeedList } from '../features/feed/FeedList';
import type { Category } from '../lib/api';
import { CATEGORIES, categoryLabel } from '../lib/categories';
import styles from './Page.module.css';

const ORDER: Category[] = ['alert', 'lost_found', 'question', 'recommendation', 'note'];

/** The same board, filtered to one kind of note. */
export function Notices() {
  const [params] = useSearchParams();
  const requested = params.get('label') as Category | null;
  const category: Category = requested && CATEGORIES.some((c) => c.value === requested) ? requested : 'alert';

  return (
    <div className={styles.stack}>
      <header>
        <h1 className={styles.pageTitle}>Notices</h1>
        <p className={styles.lede}>Notes your neighbors labeled, newest first.</p>
      </header>
      <nav className={styles.filters} aria-label="Labels">
        {ORDER.map((value) => (
          <Link
            key={value}
            to={`/notices?label=${value}`}
            className={styles.filter}
            aria-current={value === category ? 'page' : undefined}
          >
            {categoryLabel(value)}
          </Link>
        ))}
      </nav>
      <FeedList
        key={category}
        filter={{ category }}
        endMessage={`That's every ${categoryLabel(category).toLowerCase()} note nearby.`}
        empty={
          <Paper>
            <EmptyState art={<EmptyBoard />} title={`No ${categoryLabel(category).toLowerCase()} notes nearby`}>
              When a neighbor labels a note “{categoryLabel(category)},” it shows up here.
            </EmptyState>
          </Paper>
        }
      />
    </div>
  );
}
